<template>
     <div class=" flex justify-center items-center">
    <div class="spinner w-12 h-12 rounded-full animate-pulse	">
      <div class=" bg-black rounded-full w-8 h-8"></div>
    </div>
  </div>
</template>
<script setup>
</script>